<template>
    <section>
        <div class='container'>
            <div class='text-title'>
                Activation Troubleshooting
                <p class='text-caption text-italic' runat='server'>Applies to: {{ appliesToText }}</p>
            </div>
            <p>
                If you experience any problems when attempting to input and apply your Activation Code, please follow through
                the troubleshooting steps and tips shown below.
            </p>

            <p>
                If you need help on locating where to input your Activation Code, refer to the <router-link to='/Support/Help/Enter-Activation'>Entering an Activation Code</router-link> page.
            </p>

            <span class='text-subtitle'>Troubleshooting Steps</span>
            <ol class='help-listStyle q-mt-lg'>
                <li>
                    <p>Enter the Activation Code <span class='text-weight-medium'>exactly</span>, for example:</p>
                    <ul>
                        <li>Include all dashes ( '-' )</li>
                        <li>Use upper case characters</li>
                        <li>Do not include any <span class='text-weight-medium'>spaces</span> (check the end of the field if you pasted the code into it)</li>
                        <li>Check carefully for the letter <span class='text-weight-medium'>'O'</span> versus the number <span class='text-weight-medium'>'0'</span> (zero), and vice versa</li>
                        <img class="img-fit" :src="require('@/assets/img/help/EnteringAC.jpg')" />
                    </ul>
                </li>
                <li>
                    <p>
                        Confirm that the code you are using is in fact an Activation Code. Other codes, like Install ID's, Discount Codes or Prepaid Codes, will not work to activate your software.
                    </p>

                    <div class='helpTable'>
                        <p class='text-subtitle'>Activation Codes</p>

                        <table>
                            <tr>
                                <td class='q-pr-md'>
                                    General
                                </td>
                                <td>XXXX-XXXX-XXXX-XXXX-XXXX</td>
                            </tr>
                            <tr>
                                <td class='q-pr-md'>OEM</td>
                                <td>XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX</td>
                            </tr>
                        </table>

                        <p class='text-subtitle'>NOT Activation Codes:</p>
                        <table>
                            <tr>
                                <td class='q-pr-md'>
                                    Install ID
                                </td>
                                <td>XXXX-XXXX-XXXX</td>
                            </tr>
                            <tr>
                                <td class='q-pr-md'>Prepaid Codes</td>
                                <td>
                                    LC2XX-####<br />
                                    LC2XX-XX-####
                                </td>
                            </tr>
                        </table>
                    </div>
                </li>
                <li>
                    <p>
                        Make sure you have installed the <span class='text-weight-medium'>correct version of the program</span>. An Activation Code issued for the {{ LCYear }}
                        software will not work in the {{ LCPreviousYear }} or earlier versions.
                    </p>

                    <p class='helpTable'>
                        Download Links:
                        <ul class="q-my-md" style='list-style-type: none;'>
                            <li><router-link to='/Download/LoopCAD'>www.LoopCAD.com/Downloads</router-link></li>
                            <li><router-link to='/Download/HeatCAD'>www.HeatCAD.com/Downloads</router-link></li>
                            <li><router-link to='/Download/PlumbingCAD'>www.PlumbingCAD.com/Downloads</router-link></li>
                        </ul>
                    </p>
                </li>
                <li>
                    If you have an <span class='text-weight-medium'>OEM sponsored license</span>, check that you running the correct OEM Edition. Your Activation Code will only work in that OEM Edition of LoopCAD.
                    <div class='helpTable'>See download links above.</div>
                </li>
                <li>
                    <p>Try to automatically retrieve and apply your Activation Code by clicking the <span class='text-weight-medium'>Update Activation</span> button located on the Activation form. You will be prompted to login to your account.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/UpdateActivation.jpg')" />
                </li>
                <li>
                    Verify that you have the correct software installed - LoopCAD or HeatCAD. See download links above.
                </li>
                <li>
                    <p>If you have moved your software to a new or different computer, complete the steps needed to request a new activation code.</p>
                    <div class='helpTable'>
                        Go to <router-link to='/Support/Help/Reactivate'>Reactivation on a New Computer</router-link>
                    </div>
                </li>
                <li>
                    If you still are having problems, please contact <router-link to='/Support/Ticket'>Technical Support</router-link>.
                </li>
            </ol>
        </div>
    </section>
</template>
<script>
    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'troubleshoot',
        data() {
            return {
                appliesToText: productLines.LoopCAD.name + ' ' + productLines.LoopCAD.year + ', '
                    + productLines.HeatCAD.name + ' ' + productLines.HeatCAD.year + ', '
                    + productLines.PlumbingCAD.name + ' ' + productLines.PlumbingCAD.year,
                LCYear: productLines.LoopCAD.year,
                LCPreviousYear: productLines.LoopCAD.year - 1
            }
        }
    }
</script>
